<template>
  <div class="exception-board-wrapper">
    <v-card flat class="exception-board-card pa-4">
      <div class="exception-board-header mb-3">
        <h2 class="board-title">Exception Report</h2>
      </div>
      <ExceptionTable />
    </v-card>
  </div>
</template>
<script>
import ExceptionTable from './ExceptionTable.vue'
export default {
  components: {
    ExceptionTable
  },
  data() {
    return {
      data: []
    }
  }
}
</script>
<style scoped>
.exception-board-wrapper {
  width: 100%;
  min-height: 100%;
}

.exception-board-card {
  width: 100%;
  background: #ffffff;
}

.board-title {
  font-size: 22px;
  font-weight: 700;
  color: #212121;
  margin: 0;
  padding: 0;
}
</style>